



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import { ListSection } from '@/store/models';

@Component({ components: {} })
export default class List extends Vue {
  @Prop() readonly section!: ListSection;
  @Prop({ default: false }) readonly fixed!: boolean;
  @Prop({ default: false }) readonly expandable!: boolean;

  title: string = '';
  rows: any = [];

  @Watch('section', { immediate: true, deep: true })
  onData() {
    this.init();
    this.title = this.section.Title;
    if (this.section.Items) {
      for (let i = 0; i < this.section.Items.length; i++) {
        const s = this.section.Items[i];
        this.rows[i].text = s.Value;
        this.rows[i].checked = s.Marked;
      }
    }
    if (this.section.Hidden !== this.hidden) {
      this.update();
    }
  }

  @Watch('title', { immediate: false, deep: false })
  titleChanged() {
    if (this.section.Title === this.title) {
      return;
    }
    this.update();
  }

  @Watch('rows', { immediate: false, deep: true })
  rowsChanged() {
    if (JSON.stringify(this.storeItems()) === JSON.stringify(this.items())) {
      return;
    }
    this.update();
  }

  update() {
    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.section.SubType,
      Title: this.title,
      Items: this.items(),
      Hidden: this.hidden,
    };

    dokument.updateItem(s);
  }

  get hidden(): boolean {
    if (this.section.Title) {
      return false;
    }
    return (
      !this.section.Items ||
      this.section.Items.filter((x: any) => x.Value).length === 0
    );
  }

  items() {
    return this.rows.map((r: any) => {
      return { Value: r.text, Marked: r.checked };
    });
  }

  storeItems() {
    if (!this.section.Items) {
      return [];
    }
    return this.section.Items.map((r: any) => {
      return { Value: r.Value, Marked: r.Marked };
    });
  }

  init() {
    this.title = '';
    if (this.section.SubType === 'preClosingMeeting_thisYear') {
      this.rows = [
        {ph: 'Ex. Försäljningsökning', checked: false, text: ''},
        {ph: 'Ex. Höga personalkostnader', checked: false, text: ''},
        {ph: 'Ex. God likviditet', checked: false, text: ''},
        {ph: '', checked: false, text: ''},
        {ph: '', checked: false, text: ''},
      ];
    } else if (this.section.SubType === 'preClosingMeeting_remaining') {
      this.rows = [
        {ph: 'Ex. Decemberförsäljning', checked: false, text: ''},
        {ph: 'Ex. Pensionsinbetalning', checked: false, text: ''},
        {ph: 'Ex. Investeringar', checked: false, text: ''},
        {ph: '', checked: false, text: ''},
        {ph: '', checked: false, text: ''},
      ];
    } else if (this.section.SubType === 'preClosingMeeting_misc') {
      this.rows = [
        {ph: 'Ex. Skattetips', checked: false, text: ''},
        {ph: 'Ex. Hållbarhetsredovisning', checked: false, text: ''},
        {ph: 'Ex. Aktieägaravtal', checked: false, text: ''},
        {ph: '', checked: false, text: ''},
        {ph: '', checked: false, text: ''},
      ];
    } else {
      this.rows = [
        {ph: 'Rad 1', checked: false, text: ''},
        {ph: 'Rad 2', checked: false, text: ''},
        {ph: 'Rad 3', checked: false, text: ''},
        {ph: 'Rad 4', checked: false, text: ''},
        {ph: 'Rad 5', checked: false, text: ''},
      ];
    }
    if (this.section.Items) {
      for (let i = 0; i < this.section.Items.length - 5; i++) {
        this.rows.push({ ph: 'Ny rad', checked: false, text: '' });
      }
    }
  }

  addRow() {
    this.rows.push({ ph: 'Ny rad', checked: false, text: '' });
  }

  get itemCount() {
    if (!this.section.Items) {
      return 5;
    }
    return this.section.Items.length;
  }

  get fixedTitle() {
    switch (this.section.SubType) {
      case 'yearendNotes':
        return 'Noteringar';
      case 'yearendCovid':
        return 'Covid-19';
      case 'completion':
        return 'Övrigt';
      case 'sustainability':
        return 'Hållbarhet';
      case 'impressions':
        return 'Konsultintryck';
      case 'preClosingMeeting_thisYear':
        return 'Noteringar';
      case 'preClosingMeeting_remaining':
        return 'Helårsprognos';
      case 'preClosingMeeting_misc':
        return 'Övrigt';
      default:
        return '';
    }
  }
}
